<main class="container-fluid">
  <header class="masthead d-flex flex-row justify-content-between align-items-end gap-4">
    <div class="d-flex flex-column align-items-start">
      <p class="eyebrow">CENTRAL BANK OF BRAZIL</p>
      <h1>BCB Policy / Brazil</h1>
      <p class="lede">Brazil fiscal years with Selic changes and normalized economic series.</p>
    </div>
    <a href="/">Federal Reserve chart</a>
  </header>

  @if (dashboard$ | async; as dashboard) {
    <section class="chart-card">
      <div class="section-heading d-flex flex-column align-items-start gap-3">
        <div class="chart-description d-flex flex-column align-items-start gap-1">
          <p class="eyebrow">FISCAL LOG SCALE · 1–10</p>
          <h2>{{ dashboard.dataset.fiscalWindow }}</h2>
        </div>
        <div class="legend d-flex flex-row flex-nowrap align-items-center gap-2 w-100">
          @for (series of dashboard.dataset.series; track series.key) {
            <button type="button" class="d-inline-flex flex-row align-items-center flex-shrink-0 gap-1"
              [class.active]="isVisible(series.key)" [attr.aria-pressed]="isVisible(series.key)"
              [attr.title]="series.description" (click)="toggle(series.key)">
              <b class="series-key flex-shrink-0" [style.background]="series.color"></b>{{ series.label }}
            </button>
          }
        </div>
      </div>
      <div class="line-chart d-flex flex-column w-100">
        @for (row of dashboard.years; track row.year) {
          <app-fiscal-row>
            <div row-header class="row-header d-flex flex-row justify-content-between align-items-center w-100">
              <h3>Brazil FY {{ row.year }}</h3>
            </div>
            <app-bcb-chart row-chart [row]="row" [visibleKeys]="visibleKeys()" />
            <app-bcb-rate-table row-table [row]="row" />
          </app-fiscal-row>
        }
      </div>
    </section>
  } @else {
    <section class="empty d-flex flex-column align-items-center justify-content-center">
      <h2>Loading Brazil policy data…</h2>
    </section>
  }
</main>
